export default "__VITE_PUBLIC_ASSET__3b29e18e__"